import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "PlanningListPage" */
	'pages/intervention/Planning/PlanningListPage'));

export default [{ component, exact: true, path: '/plannings' }];